var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/esn.calendar.libs/app/components/event-date-suggestion/event-date-suggestion.pug");
module.exports = (req['default'] || req).apply(req, [])